import React from 'react';
import FooterWithImage from '@components/layout/FooterWithImage';
import useMeQuery from '@hooks/useMeQuery';
import useLocaleForQueries from '@hooks/useLocaleForQueries';
import { useAppReducer } from './AppReducer';

export default function Footer(): JSX.Element {
  const { data, loading } = useMeQuery();
  const { setLocale } = useAppReducer();
  const locale = useLocaleForQueries();

  const eventPrivacyPolicy = data?.me?.event?.links?.privacyPolicy;
  const cventPrivacyPolicyText = data?.me?.event?.cventPrivacyPolicyText;
  const eventLink = data?.me?.event?.links?.summary;
  const hideCventFooter = loading ? true : data?.me?.event?.accountConfig?.hideCventFooter;
  const webConfig = data?.me?.event?.appConfig?.webConfig;
  const supportedEventLocales = data?.me?.event?.supportedEventLocales;
  const ccpaUrl = data?.me?.event?.links?.ccpa;
  const showCookieBanner = data?.me?.event?.showCookieBanner;
  const showNonEssentialCookieBanner = data?.me?.event?.showNonEssentialCookieBanner;
  const showCookieBannerPrivacyPolicyLink = data?.me?.event?.showCookieBannerPrivacyPolicyLink;
  const codeSnippets = data?.me?.event?.codeSnippets || [];

  return (
    <FooterWithImage
      eventLink={eventLink}
      hideCventFooter={hideCventFooter}
      eventPrivacyPolicy={eventPrivacyPolicy}
      cventPrivacyPolicyText={cventPrivacyPolicyText}
      footerImageSrc={webConfig?.footerImage}
      footerImageAltText={webConfig?.footerImageAltText}
      supportedEventLocales={supportedEventLocales}
      setLocale={setLocale}
      locale={locale}
      eventId={data?.me?.event?.id}
      ccpaUrl={ccpaUrl}
      enableManageCookiePreferences={showCookieBanner && showNonEssentialCookieBanner}
      showCookieBanner={showCookieBanner}
      showNonEssentialCookieBanner={showNonEssentialCookieBanner}
      hidePrivacyPolicyLink={!showCookieBannerPrivacyPolicyLink}
      codeSnippets={codeSnippets}
    />
  );
}
